<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page perfis-usuario-page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButton
            text="Novo perfil"
            type="primario"
            beforeIcon="fas fa-plus"
            @click="onNew"
          />
        </FormButtonGroup>
      </template>

      <PerfisInfoAlert>
        Perfis sem planos de pagamento vinculados funcionam como
        <strong>Sem restrição</strong> no LifeGrowth (todas as formas da loja
        permanecem disponíveis para o usuário, respeitando demais regras do
        sistema).
      </PerfisInfoAlert>

      <DataTable
        ref="datatable"
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        search
        searchLabel="Buscar nome ou descrição"
        noHideFilters
        sortBy="nome"
        :sortDesc="false"
        :itemsPerPage="15"
        :limitPage="[10, 15, 25, 50]"
        classe="elevation-0"
        @click="onRowClick"
      >
        <template v-slot:nome="{ col }">
          <span class="perfis-col-with-icon">
            <v-icon color="primario" class="perfis-col-icon mr-1" size="14">
              fas fa-user-tag
            </v-icon>
            <span>{{ col || "—" }}</span>
          </span>
        </template>
        <template v-slot:descricao="{ col }">
          <span class="perfis-col-with-icon">
            <v-icon color="primario" class="perfis-col-icon mr-1" size="14">
              fas fa-align-left
            </v-icon>
            <span v-if="col">{{ col }}</span>
            <span v-else class="grey--text">—</span>
          </span>
        </template>
        <template v-slot:ativo="{ col }">
          <Chip
            v-if="col"
            color="green"
            :small="true"
            dense
            rounded
            text="ATIVO"
            icon="fas fa-check-circle"
            :icon-size="14"
          />
          <Chip
            v-else
            color="grey"
            :small="true"
            dense
            rounded
            text="INATIVO"
            icon="fas fa-minus-circle"
            :icon-size="14"
          />
        </template>
        <template v-slot:qtd_usuarios="{ row }">
          <Chip
            color="primario"
            :small="true"
            dense
            outlined
            rounded
            :text="String(Number(row.qtd_usuarios) || 0)"
            icon="fas fa-users"
            :icon-size="14"
            class="perfis-qtd-chip"
          />
        </template>
        <template v-slot:acoes="{ row }">
          <FormButtonMenu
            icon
            :options="tableOptions"
            :loading="!!loadingRow[row.idperfil]"
            @click="op => selectOption(row, op)"
          >
            <v-icon size="15">fas fa-ellipsis-v</v-icon>
          </FormButtonMenu>
        </template>
      </DataTable>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import Chip from "@/components/Chip";
import DataTable from "@/components/DataTable";
import FormButton from "@/components/form/FormButton";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import FormButtonMenu from "@/components/form/FormButtonMenu";
import MarketingModules from "@/components/MarketingModules";
import confirmAlert from "@/mixins/confirmAlert";
import { mapGetters } from "vuex";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { PERFIL_USUARIO_REMOVE } from "@/store/actions/perfilUsuario";
import PerfisInfoAlert from "./PerfisInfoAlert";
import { PERFIL_STATUS_FILTER_OPTIONS } from "./perfis-usuario.constants";

export default {
  name: "PerfisUsuario",
  components: {
    Panel,
    Chip,
    DataTable,
    FormButton,
    FormButtonGroup,
    FormButtonMenu,
    MarketingModules,
    PerfisInfoAlert
  },
  mixins: [confirmAlert],
  data: () => ({
    modulosForm: [ModulesEnum.LIFEGROWTH],
    loadingRow: {},
    headers: [
      { text: "Nome", value: "nome" },
      { text: "Descrição", value: "descricao" },
      { text: "Status", value: "ativo", align: "center" },
      { text: "Usuários", value: "qtd_usuarios", align: "center" },
      {
        text: "Opções",
        value: "acoes",
        clickable: false,
        align: "center"
      }
    ],
    filters: [
      {
        label: "Status",
        query: "ativo",
        type: "autocomplete",
        options: PERFIL_STATUS_FILTER_OPTIONS,
        clearable: true
      }
    ],
    tableOptions: [
      { text: "Editar", value: "edit" },
      { text: "Excluir", value: "delete" }
    ]
  }),
  computed: {
    ...mapGetters(["getFornecedorId", "moduloFornecedorAtivo"]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    endpoint() {
      if (!this.getFornecedorId) return "";
      return `/api/v4/perfil-usuario/fornecedor/${this.getFornecedorId}/datatable`;
    }
  },
  activated() {
    this.reloadTable();
  },
  methods: {
    reloadTable() {
      if (this.$refs.datatable) {
        this.$refs.datatable.reload();
      }
    },
    onNew() {
      this.$router.push("/fornecedor/configuracao/perfis-usuarios/novo");
    },
    onRowClick(item) {
      if (!item || !item.idperfil) return;
      this.$router.push(
        `/fornecedor/configuracao/perfis-usuarios/${item.idperfil}`
      );
    },
    selectOption(item, option) {
      if (option.value === "edit") {
        return this.onRowClick(item);
      }
      if (option.value === "delete") {
        return this.onDelete(item);
      }
    },
    onDelete(item) {
      const options = {
        title: `Excluir perfil "${item.nome}"?`,
        text:
          "O perfil será removido e os vínculos de usuários e planos desta loja serão desfeitos."
      };
      this.confirmSwal(options, async () => {
        this.$set(this.loadingRow, item.idperfil, true);
        try {
          await this.$store.dispatch(PERFIL_USUARIO_REMOVE, item.idperfil);
          this.reloadTable();
        } catch (err) {
          /* ERRORS_SHOW na action */
        } finally {
          this.$set(this.loadingRow, item.idperfil, false);
        }
      });
    }
  }
};
</script>

<style scoped>
.perfis-col-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
}
.perfis-col-with-icon > span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
}
.perfis-col-icon {
  flex-shrink: 0;
}
.perfis-qtd-chip {
  font-weight: 600;
}
</style>
